import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

// const Users = lazy(() => import('../../container/pages/Users'));
// const AddUser = lazy(() => import('../../container/pages/AddUsers'));
// const DataTable = lazy(() => import('../../container/pages/UserListDataTable'));
// const Team = lazy(() => import('../../container/pages/Team'));

const Admins = lazy(() => import('../../container/users/admins'));
const AddAdmin = lazy(() => import('../../container/users/admins/Add'));
const EditAdmin = lazy(() => import('../../container/users/admins/Edit'));
const ViewAdmin = lazy(() => import('../../container/users/admins/View'));

const Members = lazy(() => import('../../container/users/members'));
const AddMember = lazy(() => import('../../container/users/members/Add'));
const EditMember = lazy(() => import('../../container/users/members/Edit'));
const ViewMember = lazy(() => import('../../container/users/members/View'));

const Roles = lazy(() => import('../../container/users/roles'));
const Permissions = lazy(() => import('../../container/users/roles/Permissions'));

function PagesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/admins`} component={Admins} />
      <Route exact path={`${path}/admins/add`} component={AddAdmin} />
      <Route exact path={`${path}/admins/view/:id`} component={ViewAdmin} />
      <Route exact path={`${path}/admins/edit/:id`} component={EditAdmin} />

      <Route exact path={`${path}/members`} component={Members} />
      <Route exact path={`${path}/members/add`} component={AddMember} />
      <Route exact path={`${path}/members/view/:id`} component={ViewMember} />
      <Route exact path={`${path}/members/edit/:id`} component={EditMember} />

      <Route exact path={`${path}/roles`} component={Roles} />
      <Route exact path={`${path}/permissions/:role`} component={Permissions} />

    </Switch>
  );
}

export default PagesRoute;
